<div mat-dialog-title>
    ผู้ที่มีส่วนร่วมในการทำแบบทดสอบ
    <div style="float: right; margin-top: -5px;">

        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()"
            style="float: right; margin-top: -6px;">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
    </div>
</div>

<mat-dialog-content class="mat-typography" style="padding: 0px 3%;">
    <div *ngIf="informantForm && informant_person" class="container pb-4">
        <p class="header py-2">
            พบ {{ countFalse }} คนยังไม่ทำแบบทดสอบนี้
        </p>
        <p class="sub-header py-2">
            คุณสามารถดูรายงานผลได้ก็ต่อเมื่อ แบบทดสอบถูกทำครบทุกคนแล้ว
        </p>
        <p class="condition py-2">
            <span class="bold">
                หมายเหตุ :
            </span>
            คุณสามารถแก้ไขอีเมลใหม่ได้ หากผู้มีส่วนร่วมคนเก่ายังไม่เริ่มทำแบบทดสอบ
        </p>

        <div *ngIf="!canAccessReport" class="d-flex justify-content-end">
            <button (click)="editInformant()" class="btn btn-outline-secondary">
                แก้ไขอีเมล
                <img class="edit" src="assets/edit.png" alt="">
            </button>
        </div>

        <form [formGroup]="informantForm">
            <div *ngFor="let p of informantForm.get('TO')['controls']; let i = index" formArrayName="TO">
                <div *ngIf="!informant_person[i].edit" class="row" [formGroupName]="i">
                    <div class="col-lg-8 col-md-8 col-sm-12 col-12 py-2" style="position: relative;">
                        <div class="d-flex justify-content-between">
                            <label [for]="informant_person[i].TAG" class="form-label">
                                {{ informant_person[i].TAG }}*
                            </label>

                            <div class="d-xxl-none d-xl-none d-lg-none d-md-none d-sm-block d-block">
                                <div *ngIf="informant_person[i].COMPLETED === 1" class="d-flex status">
                                    <img src="assets/check.png" class="icon" alt="">
                                    <div class="status-text text-success">ทำแบบทดสอบแล้ว</div>
                                </div>
                                <div *ngIf="informant_person[i].COMPLETED === 0" class="d-flex status">
                                    <img src="assets/close.png" class="icon" alt="">
                                    <div class="status-text text-danger">ยังไม่ทำแบบทดสอบ</div>
                                </div>
                            </div>
                        </div>
                        <input type="email" formControlName="MEASURE_CLIENT_EMAIL" class="form-control" disabled
                            [id]="informant_person[i].TAG" placeholder="โปรดระบุอีเมล">
                    </div>
                    <div
                        class="col-lg-4 col-md-4 col-sm-12 col-12 py-2 d-xxl-block d-xl-block d-lg-block d-md-block d-sm-none d-none">
                        <div class="d-flex">
                            <div *ngIf="informant_person[i].COMPLETED === 1" class="d-flex status">
                                <img src="assets/check.png" class="icon" alt="">
                                <div class="status-text text-success">ทำแบบทดสอบแล้ว</div>
                            </div>
                            <div *ngIf="informant_person[i].COMPLETED === 0" class="d-flex status">
                                <img src="assets/close.png" class="icon" alt="">
                                <div class="status-text text-danger">ยังไม่ทำแบบทดสอบ</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="informant_person[i].edit" class="row" [formGroupName]="i">
                    <div *ngIf="informant_person[i].COMPLETED === 0" class="col-lg-12 col-md-12 col-sm-12 col-12 py-2"
                        style="position: relative;">
                        <label [for]="informant_person[i].TAG" class="form-label">
                            {{ informant_person[i].TAG }}*
                        </label>
                        <input type="email" formControlName="MEASURE_CLIENT_EMAIL" class="form-control"
                            [id]="informant_person[i].TAG" placeholder="โปรดระบุอีเมล" (blur)="checkUser(informantForm['controls'].TO['controls'][i],
                        informantForm['controls'].TO['controls'][i].value.MEASURE_CLIENT_EMAIL , i)"
                        (focus)="checkEdit(informant_person[i])"
                        (input)="checkArray()"
                            [ngClass]="!informantForm['controls'].TO['controls'][i].valid && informant_person[i].isError ? 'border-danger' : ''">
                        <small *ngIf="!informantForm['controls'].TO['controls'][i].valid && informant_person[i].isError"
                            class="text-danger">
                            {{ informant_person[i].errorTips }}
                        </small>
                        <img *ngIf="!informantForm['controls'].TO['controls'][i].valid && informant_person[i].isError"
                            src="assets/warn.png" class="input-icon" alt="">
                        <img *ngIf="informantForm['controls'].TO['controls'][i].valid && informant_person[i].isError === false && !informant_person[i].editing"
                            src="assets/check (green).png" class="success-icon" alt="">
                    </div>
                </div>
            </div>
        </form>

        <div *ngIf="!modalData.isTake">
            <div *ngIf="isEdit" class="d-flex justify-content-center mt-3">
                <div *ngIf="canSend" (click)="changeInformant(informantForm.value)" class="btn lifedi-btn">
                    ส่งใหม่อีกครั้ง
                </div>
                <div *ngIf="!canSend" class="btn lifedi-btn disabled">
                    ส่งใหม่อีกครั้ง
                </div>
            </div>

            <div *ngIf="canAccessReport" class="d-flex justify-content-center mt-3">
                <div (click)="report()" class="btn submit-btn">
                    ดูรายงานผล
                </div>
            </div>
        </div>
        <div *ngIf="modalData.isTake">
            <div class="d-flex justify-content-center mt-3">
                <div *ngIf="!isEdit" (click)="takeMeasure()" class="btn lifedi-btn">
                    ทำแบบทดสอบ
                </div>
                <div *ngIf="isEdit" (click)="sendAndTake(informantForm.value)" class="btn lifedi-btn">
                    ส่งและเริ่มทำแบบทดสอบ
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>